import API from '../lib/api';

export const getCategoryList = () =>
	API.get('/artwork-categories/').then((response) => response);

export const getArtWorks = (params) =>
	API.get('/artworks/', params).then((response) => response);
